import { BrowserRouter as Router, Routes, Route, useLocation, useParams } from 'react-router-dom';
import { useState, useEffect } from 'react';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import MapStrip from './components/MapStrip';
import Home from './pages/Home';
import Contact from './pages/Contact';
import Presse from './pages/Presse';
import NosCreations from './pages/NosCreations';
import CertificatPage from './pages/CertificatPage';
import ProduitEntretien from './pages/ProduitEntretien';
import {
  Robinetterie,
  RobinetterieSub,
  Vasques,
  VasquesSub,
  Accessoires,
  AccessoiresSub,
} from './pages/CollectionPage';
import './styles/global.css';
import './pages/Home.css';

// Scroll to top on every route change
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

// Sub-route wrappers
function RobinetterieSubRoute() {
  const { sub } = useParams();
  return <RobinetterieSub sub={sub} />;
}
function VasquesSubRoute() {
  const { sub } = useParams();
  return <VasquesSub sub={sub} />;
}
function AccessoiresSubRoute() {
  const { sub } = useParams();
  return <AccessoiresSub sub={sub} />;
}

export default function App() {
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 400) {
        setShowScrollTop(true);
      } else {
        setShowScrollTop(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <Router>
      <ScrollToTop />
      <Navbar />
      <Routes>
        <Route path="/"                          element={<Home />} />
        <Route path="/robinetterie"              element={<Robinetterie />} />
        <Route path="/robinetterie/:sub"         element={<RobinetterieSubRoute />} />
        <Route path="/vasques"                   element={<Vasques />} />
        <Route path="/vasques/:sub"              element={<VasquesSubRoute />} />
        <Route path="/accessoires"               element={<Accessoires />} />
        <Route path="/accessoires/:sub"          element={<AccessoiresSubRoute />} />
        <Route path="/creations"                 element={<NosCreations />} />
        <Route path="/garantie"                  element={<CertificatPage />} />
        <Route path="/certificat"                element={<CertificatPage />} />
        <Route path="/produit-entretien"         element={<ProduitEntretien />} />
        <Route path="/presse"                    element={<Presse />} />
        <Route path="/contact"                   element={<Contact />} />
        <Route path="*"                          element={<Home />} />
      </Routes>
      <Footer />
      <MapStrip />
      <button 
        className={`back-to-top ${showScrollTop ? 'visible' : ''}`} 
        onClick={scrollToTop} 
        aria-label="Retour en haut"
      >
        ↑
      </button>
    </Router>
  );
}
